module.exports = __webpack_public_path__ + "assets/img/demoAccess/subjects/10/main.png";